var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Viewable CTR (50%) "),_c('info-tooltip',{attrs:{"content":"50% Viewable click through rate is the number of clicks the ad received divided by the number of impressions that were 50% viewable for at least 1 second."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }